// extracted by mini-css-extract-plugin
export default {"pagination":"index_pagination__H9EHX","arrow":"index_arrow__JlW2k","disabled":"index_disabled__aVj-H","text":"index_text__tW0Qs"};